import * as Yup from "yup";

import { variables } from "../../Variables";

const { required } = variables;

export const nameSchema = Yup.object({
  name: Yup.string()
    .required("Please enter the required field")
    .matches(/^[aA-zZ\s]+$/, "Only Alphabets are Allowed for this Field "),
});

// export const imageSchema = Yup.object({
//   name: Yup.string().required(required),
// });

export const phoneSchema = Yup.object({
  phone_number: Yup.string().required(required),
});
